import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';
import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from 'services/scaffoldData/constants';
import { UnitTypesState, UnitTypesActions } from './types';

const initialState: UnitTypesState = [];

export default function (
    state: UnitTypesState = initialState,
    action: UnitTypesActions
): UnitTypesState {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED:
            return get(action, 'response.unitTypes', []);
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
